<template>
	<div class="position-fixed floating bg-white menus-listing py-1 border-bottom" id="sections-selector" :style="`left: 0; right:0; top: ${topOffset}px; z-index: 9998`">
		<div class="container d-flex">
			<div v-if="menus.length > 1" class="menu-type py-2 text-center cursor-pointer text-nowrap border font-weight-bold bg-mc text-white d-flex justify-content-between align-items-center" id="menu-type" :class="{ 'pl-4 pr-3': menus.length > 1, 'px-4': menus.length <= 1 }" v-on:click="goToNextMenu">
				<span class="mr-2">{{ menuType == 'food' ? 'drink' : 'food' }}</span>

				<i class="fa fa-exchange-alt float-right" v-if="menus.length > 1"></i>
			</div>

			<div class="menu py-2 px-3 cursor-pointer text-nowrap border font-weight-bold d-flex align-items-center" :class="{
				'menu-active active bg-food': menuType == 'food' && section.id == currentSection,
				'menu-active active bg-drink': menuType == 'drink' && section.id == currentSection
			}" v-for="section in sections" :key="section.id" v-on:click="$emit('click-on-section', section.id)">
				{{ section.name }}
			</div>

			<div class="menu-type py-2 pl-4 pr-3 text-center cursor-pointer text-nowrap border font-weight-bold bg-mc text-white d-flex justify-content-between align-items-center" v-on:click="$emit('click-on-filters')">
				<span class="mr-2">{{ $t("Filters") }}</span>

				<i class="fa fa-sort-amount-down-alt float-right"></i>
			</div>
		</div>

		<modal name="missing-menu-modal" width="100%" height="auto">
			<div class="p-3">
				<div class="text-center mt-3">
					<h3 id="modal-headline">
						{{ $t("Please note") }}
					</h3>
					<div class="mt-3">
						<p style="color: rgb(150, 35, 35)" class="text-center">
							{{ $t("The") }} <strong>{{ menuType == 'food' ? $t('drink') : $t('food') }} {{ $t("menu") }}</strong> {{ $t("is currently unavailable.") }}
						</p>
					</div>
				</div>
			</div>

			<hr />

			<div class="flex justify-content-center border-solid mt-4 pt-1 mb-4">
				<button class="btn btn-primary mr-2" v-on:click="$modal.hide('missing-menu-modal')">{{ $t("Close") }}</button>
			</div>
		</modal>
	</div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
	props: {
		sections: {
			type: Array,
			required: true
		},
		menus: {
			type: Array,
			required: true
		},
		menuType: {
			type: String,
			required: true
		},
		currentSection: {
			required: true
		}
	},
	data() {
		return {
			topOffset: 0
		};
	},
	watch: {
		currentSection: {
			immediate: true,
			handler() {
				this.$nextTick(() => {
					const menuListing = window.document.getElementsByClassName('menus-listing')[0];
					const activeElement = window.document.getElementsByClassName('menu-active')[0];
					const firstMenuType = window.document.getElementById('menu-type');

					if (!activeElement) {
						return;
					}

					menuListing.scroll({
						left: activeElement.offsetLeft - 150,
						behavior: 'smooth'
					});
				});
			}
		}
	},
	methods: {
		updateTopOffset() {
			const els = window.document.getElementsByClassName('floating');

			this.topOffset = 0;

			if (!els.length) {
				return;
			}

			for (const el of els) {
				this.topOffset += el.clientHeight;
			}

			this.topOffset -= window.document.getElementById('sections-selector').clientHeight;
		},
		goToNextMenu() {
			if (this.menus.length <= 1) {
				return this.$modal.show('missing-menu-modal');
			}

			this.$emit('change-menu', this.menuType == 'food' ? 'drink' : 'food');
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.updateTopOffset();
		});
	}
});
</script>

<style lang="scss">
.menus-listing {
	overflow-x: auto;
	overflow-y: hidden;
	background: white;

	.menu-type {
		border-radius: 15px;
		margin-right: 5px;
		text-transform: capitalize;
		height: 30px;
	}

	.menu {
		border-radius: 15px;
		margin-right: 5px;
		text-transform: capitalize;
		height: 30px;

		&.active {
			color: white;
		}

		&:not(.active):hover {
			background-color: rgb(235, 235, 235);
		}

		&:last-child {
			margin-right: 0px;
		}
	}
}
</style>
